import * as React from 'react';
import styled from 'styled-components';
import { darken, rem } from 'polished';
import { Button } from '../../Zemplin/General/Button';
import { FlexColCenter, FlexRow } from '../../Defaults/Flexbox/Flexbox';
import { DsiSvgIcon as SvgIcon, IconType } from '../General/SvgIcon';
import { IconImg, TextP } from '../../..';
import * as arrowSrc from '../../../../assets/dsi/arrow-triangle.svg';

interface Props {
  onButtonClick: any;
  onRequestClick: any;
  disabled?: boolean;
  avail_id?: number;
  hasDropdown?: boolean;
}

function ButtonWithRequest({
  onButtonClick,
  onRequestClick,
  disabled,
  avail_id = 1,
  hasDropdown = false,
}: Props) {
  const [isOpen, setIsOpen] = React.useState(false);
  const correctRotation = isOpen ? 180 : 0;
  const toggleOpen = e => {
    e.stopPropagation();
    setIsOpen(!isOpen);
  };

  const handleRequestClick = e => {
    onRequestClick();
  };

  return (
    <Wrapper>
      <CartButton
        disabled={disabled}
        type="button"
        onClick={onButtonClick}
        avail_id={avail_id}
        hasDropdown={hasDropdown}
      >
        <SvgIcon
          icon={IconType.cart}
          fill={'#FFFFFF'}
          cursor={'pointer'}
          alt="Pridať do košíka"
        />
      </CartButton>
      {hasDropdown && (
        <>
          <DropdownArrow onClick={toggleOpen} avail_id={avail_id}>
            <IconImg
              cursor={'pointer'}
              rotate={correctRotation}
              src={arrowSrc.toString()}
              alt="Šípka"
              width={8}
              height={4}
            />
          </DropdownArrow>
          {isOpen && (
            <DropdownWrapper>
              <DropdownRow type="button" onClick={handleRequestClick}>
                <StyledSvgIcon icon={IconType.compare} fill={'#CCCCCC'} />
                <TextP>{'Porovnať produkt'}</TextP>
              </DropdownRow>
              <DropdownRow type="button" onClick={handleRequestClick}>
                <StyledSvgIcon icon={IconType.favourites} fill={'#CCCCCC'} />
                <TextP>{'Do obľúbených'}</TextP>
              </DropdownRow>
            </DropdownWrapper>
          )}
        </>
      )}
    </Wrapper>
  );
}

const Wrapper = styled(FlexRow)`
  position: relative;
  justify-content: flex-end;
  min-width: ${rem(64)};
`;

const CartButton = styled(Button)<{
  avail_id: number;
  hasDropdown: boolean;
}>`
  background-color: ${({ theme, avail_id }) =>
    avail_id === 1
      ? theme.colors.stockCountAvailable
      : theme.colors.stockCountSold};
  box-shadow: 0px 1px 4px #00000014;
  border-radius: ${({ hasDropdown }) =>
    hasDropdown ? '4px 0 0 4px' : '4px 4px 4px 4px '};
  padding: ${rem(12)};

  &:hover {
    background-color: ${({ theme }) => darken(0.1, theme.colors.secondary)};
    transition: background-color 0.2s ease;
  }

  &:disabled {
    background-color: ${({ theme }) => theme.colors.disabled};
  }
`;

const DropdownArrow = styled(FlexColCenter)<{ avail_id: number }>`
  padding: ${rem(22)} ${rem(8)};
  background-color: ${({ theme, avail_id }) =>
    avail_id === 1 ? '#2D9F79' : '#C42A45'};
  border-radius: 0 ${rem(2)} ${rem(2)} 0;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => darken(0.1, theme.colors.secondary)};
    transition: background-color 0.2s ease;
  }
`;

const DropdownWrapper = styled.div`
  width: ${rem(240)};
  position: absolute;
  display: flex;
  flex-direction: column;
  top: ${rem(49)};
  right: 0;
  box-shadow: 0px 1px 24px #00000014;
  border: 1px solid #cccccc;
  box-shadow: ${({ theme }) => theme.boxShadow.default};
  color: ${({ theme }) => theme.colors.black};
  font-size: ${rem(14)};
  line-height: ${rem(22)};
  border-radius: ${rem(2)};
  z-index: 10;
  text-align: left;
  padding: 0;
`;

const DropdownRow = styled(Button)`
  background-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.black};
  border-bottom: 1px solid #cccccc;
  &:last-child {
    border: 0;
  }
`;

const StyledSvgIcon = styled(SvgIcon)`
  margin-right: ${rem(16)};
`;

export { ButtonWithRequest };
